"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rnf_invoice_0_0_1 = require("./rnf_invoice/rnf_invoice-0.0.1.json");
const rnf_invoice_0_0_2 = require("./rnf_invoice/rnf_invoice-0.0.2.json");
const rnf_invoice_0_0_3 = require("./rnf_invoice/rnf_invoice-0.0.3.json");
// Re-export the JSON files structured by format and version.
// NB: A dynamic require (require(`${format}/${format}-${version}.json`)) would prevent tree-shaking
const formats = {
    rnf_invoice: {
        '0.0.1': rnf_invoice_0_0_1,
        '0.0.2': rnf_invoice_0_0_2,
        '0.0.3': rnf_invoice_0_0_3,
    },
};
exports.default = formats;
